export const VDI_TYPES = [
  {
    id: '1',
    name: 'All Types',
  },
  {
    id: 'mmsDevices',
    name: 'MMS Devices',
  },
  {
    id: 'mmsMarkets',
    name: 'MMS Markets',
  },
  {
    id: 'mmsProducts',
    name: 'MMS Products',
  },
  {
    id: 'mmsSales',
    name: 'MMS Sales',
  },
  {
    id: 'vdiPeriodTotals',
    name: 'VDI Period Totals',
  },
  {
    id: 'vdiPeriodSalesTransactions',
    name: 'VDI Period Sales Transactions',
  },
  {
    id: 'vdiProductSaleTransactionDetails',
    name: 'VDI Product Sales Transaction Details',
  },
];

export const VDI_VERSION = [
  {
    id: 'vdi1',
    name: 'VDI 1',
  },
  {
    id: 'vdi2',
    name: 'VDI 2',
  },
];

export const GATEWAY_TRANSACTION_PROPS = {
  VDITRANSACTION: {
    SELECT_TYPE: 'Select Type',
    TYPE: 'VDI Type',
    SELECT_VERSION: 'Select Version',
    VERSION: 'Version',
    SELECT_STATUS: 'Select Status',
    STATUS: 'Status',
    AUTO_REFRESH_LABEL: 'Auto Refresh',
    REQUEST_ID_PLACEHOLDER: 'Request Id',
    COLUMNS: {
      VDI_REQUEST_ID: 'VDI Request Id',
      OPERATOR_INFO: 'Operator Info',
      TYPE: 'Type',
      STATUS_CODE: 'Status Code',
      TRANSACTION_DATE: 'Transaction Date',
      CREATED_ON: 'Created On',
      LAST_UPDATED: 'Updated On',
      REQUEST_STATUS: 'Request Status',
    },
  },
  BUTTON: {
    SAVE: 'SAVE',
    EDIT: 'UPDATE',
    VIEW_MESSAGE: 'View',
    CLOSE_MESSAGE: 'Close',
  },
};

export const providerName = 'provider.name';
